import React from 'react';

const Download = props => {
  return (
    <svg {...props} viewBox="0 0 48 48">
      <path
        fill="#FFC800"
        d="M24,36c0.51172,0,1.02344-0.19531,1.41406-0.58594l10-10l-2.82812-2.82812L26,29.17151V7 c0-0.55228-0.44772-1-1-1h-2c-0.55228,0-1,0.44772-1,1v22.17151l-6.58594-6.58557l-2.82812,2.82812l10,10 C22.97656,35.80469,23.48828,36,24,36z"
      />
      <path
        fill="#B3B3B3"
        d="M38,31c-0.55273,0-1,0.44775-1,1v9H11v-9c0-0.55225-0.44727-1-1-1s-1,0.44775-1,1v10 c0,0.55225,0.44727,1,1,1h28c0.55273,0,1-0.44775,1-1V32C39,31.44775,38.55273,31,38,31z"
      />
    </svg>
  );
};

export default Download;
